module.exports = __webpack_public_path__ + "static/assets/3ad7ab4906160460170cc0d04c69503a.png";